import React, { Component } from "react";

export default class PageGridItem extends Component {
	
	constructor(){
		super()
		this.state = {
			open: 		false,
			maxHeight: 0,
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
    
	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
    
    handleToggle(_el) {  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    } else {
		    this.setState({ open : true });
	    }
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
        
    handleResize() {
	  	if (this.accordionBody && this.state.open === true) {
	  		this.setState({maxHeight : this.accordionBodyInner.clientHeight});
  		} else {
	  		this.setState({maxHeight : 0});
  		}
  	}
  	 	
	render () {
		
		let item 	= this.props.item;
		let total 	= this.props.total;
		let index 	= this.props.index;
		
		let gridItemClass = 'c-grid__item';
		if (!item.text) {
			gridItemClass = 'c-grid__item c-grid__item--alt'
		}
		
		if (index === (total - 1)) {
			gridItemClass = gridItemClass + ' c-grid__item--last';
		}
										
		return (
			<div className={gridItemClass}>
				
				{item.text &&
					
					<>
						<h3 className="c-grid__item__heading" dangerouslySetInnerHTML={{__html:item.heading}}></h3>
						<div className="c-grid__item__text scope-text scope-text--small scope-text--faded" dangerouslySetInnerHTML={{__html:item.text}}></div>
					</>
				}
				
				{!item.text &&
					<h3 className="c-grid__item__heading c-grid__item__heading--desktop" dangerouslySetInnerHTML={{__html:item.heading}}></h3>
				}
				
				{item.read_more &&					
				    					
					<div className={'c-accordion__item ' + (this.state.open ? 'state-open' : "")}>
						
						{!item.text &&
							<a className="c-accordion__item__header c-accordion__item__header--alt" onClick={this.handleToggle} dangerouslySetInnerHTML={{__html:item.heading}}></a>
						}
						    																											
						<div className="c-accordion__item__body" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
						
							<div className="c-accordion__item__body__inner" ref={e => (this.accordionBodyInner = e)}>
															
								<div className="scope-text scope-text--small scope-text--faded" dangerouslySetInnerHTML={ {__html:item.read_more}}></div>
																	
							</div>
							
						</div>
						
						{item.text &&
							
							<>
							
								{this.state.open == false &&
									<a className="c-accordion__item__header" onClick={this.handleToggle} dangerouslySetInnerHTML={{__html:'Read more<svg width="6" height="10" viewBox="0 0 6 10"><path d="M0.582031 4.58203V-5.94956e-08L5.16406 4.58203L0.582031 9.16406V4.58203Z"/></svg>'}}></a>
								}
								
								{this.state.open == true &&
									<a className="c-accordion__item__header" onClick={this.handleToggle} dangerouslySetInnerHTML={{__html:'Read less<svg width="6" height="10" viewBox="0 0 6 10"><path d="M0.582031 4.58203V-5.94956e-08L5.16406 4.58203L0.582031 9.16406V4.58203Z"/></svg>'}}></a>
								}
							
							</>
						
						}
					
					</div>
				
				}
			</div>
		)
	}
}
